webpackJsonp([265137029141071],{

/***/ 64:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pageData = [{
	  order: 1,
	  title: "Ninja",
	  heading: "Ninja",
	  subheading: "Att söka efter en ninja har varit populärt inom IT-branschen. Men vad betyder det egentligen?",
	  dl1: "Det är lätt att missa bra kandidater med andra erfarenheter om man använder för snäva och kreativa uttryck.",
	  link: "/ninja/"
	}, {
	  order: 2,
	  title: "Quiz",
	  heading: "Ninja",
	  subheading: 'Ordet ninja är japanska och betyder "dold person". Inom populärkulturen är ninjor är ofta någon typ av krigare.',
	  link: "/ninja/02/",
	  quizHeading: "Vad gör en ninja på jobbet enligt dig?",
	  quizAnswer1: {
	    content: "Väljer vägen som leder till bäst resultat",
	    note: "Prioriteringskompetens"
	  },
	  quizAnswer2: {
	    content: "Förnyar eller förbättrar kontinuerligt sitt sätt att arbeta",
	    note: "Utvecklingskompetens"
	  },
	  quizAnswer3: {
	    content: "Kommer till självständiga beslut när det krävs",
	    note: "Prioriteringskompetens"
	  },
	  quizAnswer4: {
	    content: "Växlar sitt arbetstempo när det krävs",
	    note: "Anpassningskompetens"
	  },
	  quizAnswer5: {
	    content: "Ingen aning"
	  },
	  modal: {
	    heading: "Ninja",
	    subheading: "Grattis!",
	    body: "Din färdighet att undvika branschklyschor har skärpts. Slutför jakten på den oslipade diamanten.",
	    buttonText: "Slutför jakten!"
	  }
	}];
	
	exports.default = pageData;
	module.exports = exports["default"];

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(105);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Main = __webpack_require__(117);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _ModalContext = __webpack_require__(42);
	
	var _Choices = __webpack_require__(87);
	
	var _Choices2 = _interopRequireDefault(_Choices);
	
	var _floskelNinja = __webpack_require__(206);
	
	var _floskelNinja2 = _interopRequireDefault(_floskelNinja);
	
	var _gemNinja = __webpack_require__(55);
	
	var _gemNinja2 = _interopRequireDefault(_gemNinja);
	
	var _ninja = __webpack_require__(64);
	
	var _ninja2 = _interopRequireDefault(_ninja);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var currentPageData = _ninja2.default.find(function (page) {
	  return page.order === 2;
	});
	
	var Modal2 = function Modal2(_ref) {
	  var onRequestClose = _ref.onRequestClose,
	      value = _ref.value,
	      otherProps = _objectWithoutProperties(_ref, ['onRequestClose', 'value']);
	
	  return _react2.default.createElement(
	    _reactModal2.default,
	    _extends({
	      className: 'Modal',
	      overlayClassName: 'ModalOverlay',
	      isOpen: true,
	      onRequestClose: onRequestClose
	    }, otherProps),
	    _react2.default.createElement(
	      'header',
	      { className: 'Modal__header' },
	      _react2.default.createElement(
	        'span',
	        { className: 'Modal__header__text' },
	        _react2.default.createElement(
	          'span',
	          { className: 'Modal__header__headline' },
	          currentPageData.modal.heading
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'Modal__header__title' },
	          value
	        )
	      ),
	      _react2.default.createElement('img', { alt: 'Gem', src: _gemNinja2.default, className: 'Modal__header__graphic' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'Modal__body' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'Modal__header__subtitle' },
	        currentPageData.modal.subheading
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        currentPageData.modal.body
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          onClick: onRequestClose,
	          to: '/D/',
	          type: 'button',
	          className: 'Modal__footer__button button button--primary button--large mt2'
	        },
	        currentPageData.modal.buttonText
	      )
	    )
	  );
	};
	
	var Quiz = function Quiz() {
	  return _react2.default.createElement(
	    _ModalContext.ModalConsumer,
	    null,
	    function (_ref2) {
	      var showModal = _ref2.showModal;
	      return _react2.default.createElement(
	        _Choices2.default,
	        { headline: currentPageData.quizHeading },
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer1.content
	            });
	          },
	          label: currentPageData.quizAnswer1.content,
	          note: currentPageData.quizAnswer1.note
	        }),
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer2.content
	            });
	          },
	          label: currentPageData.quizAnswer2.content,
	          note: currentPageData.quizAnswer2.note
	        }),
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer3.content
	            });
	          },
	          label: currentPageData.quizAnswer3.content,
	          note: currentPageData.quizAnswer3.note
	        }),
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer4.content
	            });
	          },
	          label: currentPageData.quizAnswer4.content,
	          note: currentPageData.quizAnswer4.note
	        }),
	        _react2.default.createElement(_Choices2.default.Choice, {
	          handleClick: function handleClick() {
	            return showModal(Modal2, {
	              value: currentPageData.quizAnswer5.content
	            });
	          },
	          label: currentPageData.quizAnswer5.content
	        })
	      );
	    }
	  );
	};
	
	var Tutorial = function Tutorial() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'SectionHeader' },
	      _react2.default.createElement(
	        'span',
	        { className: 'SectionHeader__text' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SectionHeader__title' },
	          currentPageData.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'SectionHeader__lead lead' },
	          currentPageData.subheading
	        )
	      ),
	      _react2.default.createElement('img', { alt: '', src: _floskelNinja2.default, className: 'SectionHeader__graphic' })
	    )
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(_Main2.default, { currentPageNum: 2, tutorial: _react2.default.createElement(Tutorial, null), quiz: _react2.default.createElement(Quiz, null), hasNav: false });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ninja = __webpack_require__(64);
	
	var _ninja2 = _interopRequireDefault(_ninja);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _BottomNav = __webpack_require__(28);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(_ref) {
	  var currentPageNum = _ref.currentPageNum,
	      tutorial = _ref.tutorial,
	      quiz = _ref.quiz,
	      hasNav = _ref.hasNav;
	
	  // Get page data from data/pageData.js
	  var currentPageData = _ninja2.default.find(function (page) {
	    return page.order === currentPageNum;
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: 'Shell' },
	    _react2.default.createElement(
	      _Content2.default,
	      { header: true },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'Jakten | ' + currentPageData.title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main__content' },
	          tutorial
	        ),
	        quiz ? _react2.default.createElement(
	          'div',
	          { className: 'quiz-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'quiz__content' },
	            quiz
	          )
	        ) : null,
	        hasNav ? _react2.default.createElement(_BottomNav2.default, {
	          navTitle: currentPageData.navTitle,
	          currentPageNum: currentPageNum,
	          pageData: _ninja2.default
	        }) : null
	      )
	    )
	  );
	};
	
	Main.propTypes = {
	  tutorial: _propTypes2.default.node.isRequired,
	  quiz: _propTypes2.default.node,
	  hasNav: _propTypes2.default.bool,
	  currentPageNum: _propTypes2.default.number.isRequired
	};
	
	Main.defaultProps = {
	  hasNav: true,
	  quiz: ''
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ninja-02-js-d20ef7b29d9f1d105820.js